import React, { Component } from "react";
import ArcaneIcon2 from "../DeckBuilderComponents/FilterComponents/ArcaneIcon2.png";
import ChaosIcon2 from "../DeckBuilderComponents/FilterComponents/ChaosIcon2.png";
import DivineIcon2 from "../DeckBuilderComponents/FilterComponents/DivineIcon2.png";
import NatureIcon2 from "../DeckBuilderComponents/FilterComponents/NatureIcon2.png";
import TechnologyIcon2 from "../DeckBuilderComponents/FilterComponents/TechnologyIcon2.png";
import rarityCommon from "../DeckBuilderComponents/FilterComponents/Rarity_Common.png";
import rarityRare from "../DeckBuilderComponents/FilterComponents/Rarity_Rare.png";
import rarityEpic from "../DeckBuilderComponents/FilterComponents/Rarity_Epic.png";
import rarityLegendary from "../DeckBuilderComponents/FilterComponents/Rarity_Legendary.png";


class DeckRowsView extends Component {

  render() {

    var cards = this.props.decklist;
    var theThis = this;
    var preview = this.props.preview;
    var previewCard = this.props.previewCard;

    return (
      cards.map(function(Card, i){
        var imagepath = "";
        var raritypath = "";
        var previewRow = null;
        var imageAlignStyle = {
            textAlign: "center"
        }

        if (preview && Card.CardId === previewCard) {
           previewRow = <tr id='hover-row'><td colSpan='7' style={imageAlignStyle}><img alt="View Card" className='hover-image img-fluid' src={'../Images200/'+ previewCard +'.png'} /></td></tr>
        }

        if (Card.AspectIcon == "ArcaneIcon2")
        {
          imagepath = ArcaneIcon2
        }
        else if (Card.AspectIcon == "ChaosIcon2")
        {
          imagepath = ChaosIcon2
        }
        else if (Card.AspectIcon == "DivineIcon2")
        {
          imagepath = DivineIcon2
        }
        else if (Card.AspectIcon == "NatureIcon2")
        {
          imagepath = NatureIcon2
        }
        else if (Card.AspectIcon == "TechnologyIcon2")
        {
          imagepath = TechnologyIcon2
        }

        if (Card.RarityIcon == "Rarity_Common.png")
        {
          raritypath = rarityCommon
        }
        else if (Card.RarityIcon == "Rarity_Rare.png")
        {
          raritypath = rarityRare
        }
        else if (Card.RarityIcon == "Rarity_Epic.png")
        {
          raritypath = rarityEpic
        }
        else if (Card.RarityIcon == "Rarity_Legendary.png")
        {
          raritypath = rarityLegendary
        }

        return (
        <React.Fragment>
          <tr key={Card.CardId} style={{height:30}} id={Card.CardId} >
            <td style={{width:25}}>
              <img src={imagepath} alt="Aspect Icon" style={{height:25, width:25}} />
            </td>
            <td>{Card.CardName}</td>
            <td onClick={()=>theThis.props.cardPreview(Card.CardId)}  >
              <i className='fas fa-eye'></i>
            </td>
            <td>{Card.CardCost}</td>
            <td>{Card.CardQty}</td>
            <td><img alt="Rarity" style={{width: 50}} src={raritypath} /></td>
          </tr >
          {previewRow}
          </React.Fragment>
          )
      })
    );
  }
}

export default DeckRowsView;



// WEBPACK FOOTER //
// ./src/DBV2/DeckRowsView.js